import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';
import { Grid, Card, CardContent, CardActions, FormGroup, FormControlLabel, Checkbox, Tooltip, IconButton } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from 'react-i18next';
import { useModifyCodeLotMutation } from '../../features/api/rest/apiLotsSlice';
import { setAlertMessage } from '../../features/layoutSlice';
import { useNavigate } from 'react-router-dom';

function QrCodeCard({ ean, opk, lpk, code, suspect, used }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSuspect, setIsSuspect] = useState(suspect);
  const [isUsed, setIsUsed] = useState(used);
  const [modifyCodeLot] = useModifyCodeLotMutation();

  const handleSwitchChange = async (type) => {
    if (type === 'suspect') setIsSuspect(!isSuspect);
    if (type === 'used') setIsUsed(!isUsed);
    try {
      if (type === 'suspect') await modifyCodeLot({ ean, opk, lpk, id: code, payload: { suspect: !isSuspect, used: isUsed } });
      if (type === 'used') await modifyCodeLot({ ean, opk, lpk, id: code, payload: { suspect: isSuspect, used: !isUsed } });
      dispatch(setAlertMessage({ text: t('organizations.product.lots.qrCode.messages.success'), type: 'success' }));
    } catch (error) {
      dispatch(setAlertMessage({ text: t('organizations.product.lots.qrCode.messages.error'), type: 'error' }));
    }
  };

  const goToCode = () => navigate(`/products/${ean}?lots=:${code}`);

  return (
    <Card className="Product_Card">
      <Tooltip title={t('organizations.product.lots.goToCode')} placement="top">
        <IconButton onClick={goToCode} sx={{ position: 'absolute', top: 1, right: 1 }}>
          <ArrowForwardIcon />
        </IconButton>
      </Tooltip>
      <CardContent sx={{ p: 1, textAlign: 'center' }} onClick={goToCode}>
        <QRCodeSVG value={`${ean};:${code}`} />
      </CardContent>
      <CardActions sx={{ m: 0, p: 0 }}>
        <Grid container alignItems="center" sx={{ gap: 2, display: 'flex', justifyContent: 'space-evenly' }}>
          <Grid item>
            <FormGroup>
              <FormControlLabel control={<Checkbox checked={isSuspect} onChange={() => handleSwitchChange('suspect')} />} label={t('organizations.product.lots.qrCode.suspect')} labelPlacement="top" />
            </FormGroup>
          </Grid>
          <Grid item>
            <FormGroup>
              <FormControlLabel control={<Checkbox checked={isUsed} onChange={() => handleSwitchChange('used')} />} label={t('organizations.product.lots.qrCode.used')} labelPlacement="top" />
            </FormGroup>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}

export default QrCodeCard;

QrCodeCard.propTypes = {
  ean: PropTypes.string.isRequired,
  opk: PropTypes.string.isRequired,
  lpk: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  suspect: PropTypes.bool.isRequired,
  used: PropTypes.bool.isRequired,
};
